import { faUser, faBriefcase, faPhoneAlt, faMobileAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import createField from '../../utils/factory/createField';

export const contactFields = [
    {
        section: 'Dados do Contato',
        fields: [
            createField({
                id: 'contact.name',
                label: 'Nome',
                type: 'text',
                placeholder: 'Digite o nome',
                required: true,
                icon: faUser,
                fullWidth: true,
                handleChange: 'handleChange',
            }),
            createField({
                id: 'contact.surname',
                label: 'Sobrenome',
                type: 'text',
                placeholder: 'Digite o sobrenome',
                required: true,
                icon: faUser,
                fullWidth: true,
                handleChange: 'handleChange',
            }),
            createField({
                id: 'contact.role',
                label: 'Cargo',
                type: 'text',
                placeholder: 'Digite o cargo',
                required: false,
                icon: faBriefcase,
                fullWidth: true,
                handleChange: 'handleChange',
            }),
            createField({
                id: 'contact.phone',
                label: 'Telefone Fixo',
                type: 'text',
                placeholder: 'Digite o telefone',
                required: false,
                icon: faPhoneAlt,
                fullWidth: true,
                handleChange: 'handleChange',
            }),
            createField({
                id: 'contact.cell',
                label: 'Celular',
                type: 'text',
                placeholder: 'Digite o celular',
                required: false,
                icon: faMobileAlt,
                fullWidth: true,
                handleChange: 'handleChange',
            }),
            createField({
                id: 'contact.email',
                label: 'E-mail',
                type: 'email',
                placeholder: 'Digite o e-mail',
                required: true,
                icon: faEnvelope,
                fullWidth: true,
                handleChange: 'handleChange',
            }),
        ],
    },
];

export const detailsContactFields = [
    {
        section: 'Dados do Contato',
        fields: [
            createField({
                id: 'name',
                label: 'Nome',
                type: 'text',
                placeholder: 'Digite o nome',
                required: true,
                icon: faUser,
                fullWidth: true,
                handleChange: 'handleChange',
                disabled: true,
            }),
            createField({
                id: 'surname',
                label: 'Sobrenome',
                type: 'text',
                placeholder: 'Digite o sobrenome',
                required: true,
                icon: faUser,
                fullWidth: true,
                handleChange: 'handleChange',
                disabled: true,
            }),
            createField({
                id: 'role',
                label: 'Cargo',
                type: 'text',
                placeholder: 'Digite o cargo',
                required: false,
                icon: faBriefcase,
                fullWidth: true,
                handleChange: 'handleChange',
                disabled: true,
            }),
            createField({
                id: 'phone',
                label: 'Telefone Fixo',
                type: 'text',
                placeholder: 'Digite o telefone',
                required: false,
                icon: faPhoneAlt,
                fullWidth: true,
                handleChange: 'handleChange',
                disabled: true,
            }),
            createField({
                id: 'cell',
                label: 'Celular',
                type: 'text',
                placeholder: 'Digite o celular',
                required: false,
                icon: faMobileAlt,
                fullWidth: true,
                handleChange: 'handleChange',
                disabled: true,
            }),
            createField({
                id: 'email',
                label: 'E-mail',
                type: 'email',
                placeholder: 'Digite o e-mail',
                required: true,
                icon: faEnvelope,
                fullWidth: true,
                handleChange: 'handleChange',
                disabled: true,
            }),
        ],
    },
];